//縦横比を保ちつつ、領域内いっぱいに可能な限り広がるよう画像を配置した際の、幅と高さを計算
export const calcImageSize = (
  areaWidth: number, //領域の幅
  areaHeight: number,
  VBWidth: number, //画像の幅
  VBHeight: number
) => {
  const imageWidth = Math.min((areaHeight * VBWidth) / VBHeight, areaWidth);
  const imageHeight =
    (areaHeight * VBWidth) / VBHeight <= areaWidth
      ? areaHeight
      : (areaWidth * VBHeight) / VBWidth;

  return { imageWidth, imageHeight };
};
